<template>

  <div>


    <b-modal v-if="!onlySearch" v-model="hasGeneralErrors" id="modalGeneralErrors" title="Erros encontrados:" ok-only>

      <div v-for="error in generalErrors" :key="error" class="p-2 border-bottom mb-2">
        <span class="text-danger">
          <b-icon-x-circle-fill class="mr-2"/>
          <span v-html="error.replace(/\n/g,'<br />')"></span>
        </span>
      </div>

      <template #modal-footer="{ ok }">
        <t-button @click="ok()" text="Corrigir Erros" danger/>
      </template>

    </b-modal>

    <transition mode="out-in"
                enter-active-class="animated fadeInFast">

      <b-row v-show="!busy" class="fadeIn" cols="12">

        <t-field-customized v-for="item in fieldsCustomizable" :key="item.fieldId"
                            @onPressEnter="onPressEnter"
                            :field="item" v-model="item.value" :only-search="onlySearch" :big-search="bigSearch"
                            :non-conformance="getNonConformance(item.fieldId)"
                            :command="command" :status="status"/>

      </b-row>

    </transition>

    <div class="container_loading_form" v-show="busy">

      <div class="container_loading_form_card" style="height: 350px">

        <div class="gradient element-100" style="height: 30px"></div>

        <div class="gradient element-100" style="height: 100px"></div>

      </div>

    </div>


  </div>

</template>
<script>
import tFieldCustomized from "@/components/template/form/input/t-field-customized";

export default {
  name: 't-page-form-field-customized',
  components: {tFieldCustomized},
  data() {
    return {
      hasGeneralErrors: false,
      drag: false,
      type: "",
      errorList: [],
      isInvalid: false,
    }
  },
  props: {
    status: {
      type: String,
      default: ''
    },
    command: {
      type: String,
      default: 'insert'
    },
    errorField: Object,
    generalErrors: Array,
    onlySearch: {
      type: Boolean,
      default: false,
    },
    bigSearch: Boolean,
    fieldsCustomizable: Array,
    nonConformanceFields: {
      type: Array,
    },
    title: String,
    userAuth: Object,
    items: Array,
    primaryKey: Number,
    foreignKey: Number,
    foreignKeyColumn: {
      type: String,
      required: false,
    },
    primaryKeyColumn: {
      type: String,
      required: false,
    },
    busy: {//busy principal
      type: Boolean,
      default: false,
    },
  },
  mounted() {

    this.hasGeneralErrors = this.generalErrors && this.generalErrors.length > 0

  },
  methods: {

    onPressEnter() {
      //Envia informando que o enter foi pressinado
      this.$emit("onPressEnter")
    },

    getNonConformance(fieldId){

      if(this.nonConformanceFields !== undefined && this.nonConformanceFields !== null && this.nonConformanceFields.length > 0){
        return this.nonConformanceFields.find(a => a.fieldId === fieldId)
      }

    }



  }
}
</script>
<style scoped>
</style>
